import { bdayPost, bdayPut, bdayGet, bdayDelete } from 'services/utils';

const baseApi = '/api/1';

export const getUser = (data) => {
  return bdayGet(`${baseApi}/login${data ? data : ''}`);
}
export const login = (data) => {
  const payload = data;
  payload.loginType = 'email';
  return bdayPost(`${baseApi}/login`, payload);
}
export const getMembershipInfo = (data) => {
  return bdayPost(`${baseApi}/membership_info${data ? data : ''}`);
}
export const updateNotification = (payload) => {
  return bdayPut(`${baseApi}/notifications`, payload);
}
export const register = (data) => {
  const payload = data;
  payload.registerType = 'email';
  return bdayPost(`${baseApi}/register`, payload);
}
export const isUser = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/check_email`, payload);
}
export const unbounceEmail = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/email/unbounce`, payload);
}
export const acceptCookies = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/accept_cookies`, payload);
}
export const openTicket = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/open_ticket`, payload);
}
export const closeAccount = () => {
  return bdayPost(`${baseApi}/account/close`, {});
}
export const deleteAccount = () => {
  return bdayPost(`${baseApi}/account/delete`, {});
}
export const updateSettings = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/account/settings`, payload);
}
export const receiveReminder = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/account/email/receive`, payload);
}
export const changePassword = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/account/password`, payload);
}
export const uploadUserPhoto = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/account/photo`, payload);
}
export const deleteUserPhoto = (data) => {
  const payload = data;
  return bdayDelete(`${baseApi}/account/photo/${payload.photoId}`, payload);
}
export const unsubscribe = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/unsubscribe`, payload);
}
export const resetPassword = (data) => {
  const payload = data;
  return bdayPost(`${baseApi}/account/password/reset`, payload);
}
export const logout = () => {
  return bdayGet(`${baseApi}/logout`);
}
export const logoutAdminMember = () => {
  return bdayDelete(`${baseApi}/admin/login`);
}
